import React, { useEffect, useContext, useState } from 'react';
import { ContractContext } from '../contexts/ContractContext';
import { HWAHeader } from './HWAHeader/HWAHeader';
import { Header } from '../Header';
import AppleHeader from '../Vendor/Apple/AppleHeader';
import { isAppleRoute, isHWAChatEndRoute } from '../../helpers';
import NJRHeader from './NJRHeader/NJRHeader';
import { ETHeader } from './ETHeader/ETHeader';
import { CutlerHeader } from './CutlerHeader/CutlerHeader';
import ConstellationHeader from './ConstellationHeader/ConstellationHeader';
import HomekickHeader from './HomekickHeader/HomekickHeader';
import RateHeader from './RateHeader/RateHeader';
import FlexHeader from './FlexHeader/FlexHeader';
import SureHeader from './SureHeader/SureHeader';

export const HeaderController = (props) => {
    const context = useContext(ContractContext);
    const {
        data: { clientId }
    } = context;
    const checkParams = new URLSearchParams(window.location.search);

    // useEffect(() => {
    //     if (brandContext.clientId !== null) {
    //         setClientId(brandContext.clientId.toLowerCase());
    //     } else {
    //         const hwaChat = async () => {
    //             const result = await isHWAChatEndRoute();
    //             console.log(result);
    //             if (result == true) {
    //                 setClientId('hwa');
    //             }
    //         };
    //         hwaChat();
    //     }
    // }, [brandContext.clientId]);

    if (clientId === null || clientId === undefined || clientId === 'AIG' || clientId?.toLowerCase() === 'apple') {
        if (
            isAppleRoute()
            && (!window.location.pathname.toLowerCase().includes('chatend')
                || !window.location.pathname.toLowerCase().includes('chat'))
        ) {
            return <AppleHeader />;
        }
    }

    switch (clientId?.toLowerCase()) {
        case 'apple':
            return <AppleHeader />;
        case 'hwa':
            return <HWAHeader />;
        case 'njr':
            return <NJRHeader />;
        case 'et':
            return <ETHeader {...props} />; //To see ET header, change the return value to true in ETRoute in helpers.jsx
        case 'cutler':
            return <CutlerHeader />;
        case 'constellation':
            return <ConstellationHeader {...props} />;
        case 'homekick':
            return <HomekickHeader {...props} />;
        case 'rate':
            return <RateHeader {...props} />;
        case 'flex':
            return <FlexHeader {...props} />;
        case 'sure':
            return <SureHeader {...props} />;
        case 'applestandalone':
        case 'arw':
        default:
            return <Header {...props} />;
    }
};
